<div class="login-container">
  <h2>Iniciar sesión con Wise ID</h2>
  <div class="login-buttons">
    <button
      class="auth-btn"
      type="button"
      (click)="loginWithUsernamePassword()"
    >
      <div>Usuario y Contraseña</div>
      <div class="auth-icon">
        <img
          src="assets/static/icons//account-key.svg"
          alt="Usuario y Contraseña"
        />
      </div>
    </button>
    <button class="auth-btn" type="button" (click)="loginWithQRCode()">
      <div>Código QR</div>
      <div class="auth-icon">
        <img src="assets/static/icons/qr-code.svg" alt="Código QR" />
      </div>
    </button>
  </div>
  <div class="login-footer">
    <p>
      ¿No tienes una cuenta?
      <a
        target="_blank"
        href="https://des-usso.wsg127.com/usso_portal1/enrollUser.xhtml"
        >Regístrate aquí</a
      >
    </p>
  </div>
</div>
